import { MAX_WORD_LENGTH } from '../../constants/settings'
import { Cell } from './Cell'

export const EmptyRow = () => {
  const firstemptyCells = Array.from(Array(MAX_WORD_LENGTH / 2))
  const secondemptyCells = Array.from(Array(MAX_WORD_LENGTH / 2))
  const pointerclasses = 'w-8 h-14 flex items-center justify-center mx-0.5 text-4xl font-bold rounded dark:text-white'

  return (
    <div className="flex justify-center mb-1">
	<div className={pointerclasses}>
    	<div className="letter-container">
			<br/>
		</div>
		</div>
		
      {firstemptyCells.map((_, i) => (
        <Cell key={i} />
      ))}
    
	<Cell key ="5" value="-" />
	
	  {secondemptyCells.map((_, i) => (
        <Cell key={i} />
      ))}
	  
	  <div className={pointerclasses}>
    	<div className="letter-container">
			<br/>
		</div>
		</div>
		
    </div>
  )
}
